module.exports = __webpack_public_path__ + "assets/img/index-box2-5.3b509b16.png";